import { render, staticRenderFns } from "./VmInventory.vue?vue&type=template&id=0973e720&scoped=true&"
import script from "./VmInventory.vue?vue&type=script&lang=js&"
export * from "./VmInventory.vue?vue&type=script&lang=js&"
import style0 from "./VmInventory.vue?vue&type=style&index=0&id=0973e720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973e720",
  null
  
)

export default component.exports